import { render, staticRenderFns } from "./CommonTalkToTeam.vue?vue&type=template&id=5fff7ecc&scoped=true&"
import script from "./CommonTalkToTeam.vue?vue&type=script&lang=ts&"
export * from "./CommonTalkToTeam.vue?vue&type=script&lang=ts&"
import style0 from "./CommonTalkToTeam.vue?vue&type=style&index=0&id=5fff7ecc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fff7ecc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonSalesDialog: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/common/CommonSalesDialog.vue').default})
